console.log('[packaging-fee] loaded v3');

const FEE_VARIANT_ID = 48905616523357;
const SECTION_ID = 'cart-drawer-section';
const DRAWER_SELECTOR = '[data-hydration-key="cart-drawer-inner"]';

let busy = false;
let rerun = false;

async function getCart() {
  const res = await window.fetch('/cart.js');
  return res.json();
}

function countItems(cart) {
  let pieces = 0;
  let fee = 0;
  for (const item of cart.items) {
    if (item.variant_id === FEE_VARIANT_ID) fee += item.quantity;
    else pieces += item.quantity;
  }
  return { pieces, fee };
}

function renderDrawer(sections) {
  const html = sections && sections[SECTION_ID];
  if (!html) return false;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const next = doc.querySelector(DRAWER_SELECTOR);
  const current = document.querySelector(DRAWER_SELECTOR);
  if (!next || !current) return false;
  current.className = next.className;
  current.innerHTML = next.innerHTML;
  return true;
}

async function applyFee(desired, currentFee) {
  const isAdd = desired > 0 && currentFee === 0;
  const res = await window.fetch(isAdd ? '/cart/add.js' : '/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(
      isAdd
        ? { items: [{ id: FEE_VARIANT_ID, quantity: desired }], sections: SECTION_ID }
        : { id: String(FEE_VARIANT_ID), quantity: desired, sections: SECTION_ID }
    ),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.description || 'Packaging update failed');
  if (!renderDrawer(data.sections)) window.location.reload();
}

// Keeps the fee quantity equal to (pieces - 1) while the fee line exists
async function syncFee() {
  console.log('[packaging-fee] syncFee called, busy =', busy);
  if (busy) {
    rerun = true;
    return;
  }
  busy = true;
  try {
    const { pieces, fee } = countItems(await getCart());
    if (fee === 0) return;
    const desired = pieces > 1 ? pieces - 1 : 0;
    if (desired !== fee) await applyFee(desired, fee);
  } catch (error) {
    console.warn('[packaging-fee]', error);
  } finally {
    busy = false;
    if (rerun) {
      rerun = false;
      syncFee();
    }
  }
}

// Watch every cart change made by the theme (add, change, update, clear)
if (!window.__packagingFeeWrapped) {
  window.__packagingFeeWrapped = true;
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    try {
      const input = args[0];
      const url = typeof input === 'string' ? input : input?.url || '';
      const method = (args[1]?.method || input?.method || 'GET').toUpperCase();
      if (method === 'POST' && /\/cart\/(add|change|update|clear)/.test(url) && response.ok) {
        setTimeout(syncFee, 400);
      }
    } catch (error) {
      console.warn('[packaging-fee]', error);
    }
    return response;
  };
}

// Customer ticks or unticks the toggle
document.addEventListener('change', async (event) => {
  const toggle = event.target;
  if (!(toggle instanceof HTMLInputElement) || toggle.id !== 'separate-packaging-toggle') return;
  if (busy) {
    toggle.checked = !toggle.checked;
    return;
  }
  busy = true;
  toggle.disabled = true;
  try {
    const { pieces, fee } = countItems(await getCart());
    const desired = toggle.checked && pieces > 1 ? pieces - 1 : 0;
    if (desired !== fee) await applyFee(desired, fee);
  } catch (error) {
    console.warn('[packaging-fee]', error);
    toggle.checked = !toggle.checked;
  } finally {
    toggle.disabled = false;
    busy = false;
  }
});

// Extra safety net: re-check the fee whenever the drawer changes or is used
function watchDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return false;

  let timer;
  const schedule = (delay) => {
    clearTimeout(timer);
    timer = setTimeout(syncFee, delay);
  };

  // The theme redraws the drawer after any cart change
  new MutationObserver(() => schedule(600)).observe(drawer, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  // Quantity buttons, remove buttons and quantity inputs
  drawer.addEventListener('click', () => schedule(1200));
  drawer.addEventListener('change', (event) => {
    if (event.target.id !== 'separate-packaging-toggle') schedule(1200);
  });

  return true;
}

if (!watchDrawer()) document.addEventListener('DOMContentLoaded', watchDrawer);